/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useSelector } from 'react-redux';
import SessionStorage from '@vantiva-sa/homesight_humaui/Utilities/SessionStorage';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { AppStorageKeys } from '@vantiva-sa/homesight_humaui/Utilities/Constants';

import LanguageIcon from '../../../static/icons/language.svg?img';
import MailIcon from '../../../static/icons/mail.svg?img';
import CallIcon from '../../../static/icons/call.svg?img';
import { LoadingOutlined } from '@ant-design/icons';
import { NewRedirectIcon } from '../Common/Icons';
const ENV_VARS = SessionStorage.get(AppStorageKeys.envVars);

const SupportCardInfo = ({ userConfigData, loading }) => {
  const trans = useSelector(translator);

  return (
    <>
      <h1 className="help-page-card-header">{trans('CONTACTUS')}</h1>
      <div className="help-page-card-information">
        {loading ? (
          <div className="help-page-card-data-group">
            <LoadingOutlined />
          </div>
        ) : (
          <>
            {userConfigData && userConfigData['website'] ? (
              <div className="help-page-card-data-group">
                <img alt="care" src={LanguageIcon} />
                <a
                  href={
                    userConfigData['website']?.startsWith('http')
                      ? userConfigData['website']
                      : `https://${userConfigData['website']}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#3FA9F5', textDecoration: 'underline' }}
                  className="help-page-data-label"
                >
                  {userConfigData['website']}
                </a>
                <NewRedirectIcon />
              </div>
            ) : null}
          </>
        )}
        {loading ? (
          <div className="help-page-card-data-group">
            <LoadingOutlined />
          </div>
        ) : (
          <>
            {userConfigData && userConfigData['email'] ? (
              <div className="help-page-card-data-group">
                <img alt="mail" src={MailIcon} />
                <p className="help-page-data-label">{userConfigData['email']}</p>
              </div>
            ) : null}
          </>
        )}
        {loading ? (
          <div className="help-page-card-data-group">
            <LoadingOutlined />
          </div>
        ) : (
          <>
            {userConfigData && userConfigData['contact'] ? (
              <div className="help-page-card-data-group">
                <img alt="contact" src={CallIcon} />
                <p className="help-page-data-label">{userConfigData['contact']}</p>
              </div>
            ) : null}
          </>
        )}
      </div>
    </>
  );
};

export default SupportCardInfo;
